import { State } from 'redux/utils/Value'

export default State()